import React, { useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router';
import Head from '../../layout/head/Head';
import Content from "../../layout/content/Content";
import { Card } from 'reactstrap';
import DispatchComponent from './dispatchComponent';
import DispatchAside from './dispatchAside';

function ShowDispatchDetailsWrapper() {
  let { id }: any = useParams();
  const location = useLocation();
  const [sm, setSm] = useState(false);
  const hideAside = location.state?.hideAside || false;
  const previousPath = location.state?.previousPath || "/view-dispatch-list";

  return (
    <>
      <Head title="Material Invoice" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {!hideAside && (
              <div
                className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg 
                  ${sm ? "content-active" : ""}
                `}
              >
                <DispatchAside updateSm={setSm} sm={sm} />
              </div>
            )}
              <DispatchComponent dispatchNumber={id} previousPath={previousPath}/>
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ShowDispatchDetailsWrapper